/*=========================================================================================
	File Name: moduleAuthState.js
	Description: Auth Module State
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


//import auth from '@/auth/authService'

export default {
	isUserLoggedIn: (store) => {
		return localStorage.getItem("fullFilmentTokenId") == "null" ? false : true
	},
	setToken(state, data) {
	 
		state.ROLE = data.ROLE;
		state.servisAdresi = data.servisAdresi;
		state.fullFilmentTokenId = data.fullFilmentTokenId;
		state.userCode = data.userCode;
		state.userName = data.userName;
		state.expiration = data.expiration;
		state.userId = data.userId;
		state.companyId = data.companyId;
	},

}
